import { Locales, routingLocaleToLanguageTag } from '@bridebook/web/lib/i18n/constants';

/**
 * Returns a lang attribute to be added in <html> tag
 * @param locale
 */
export const getHtmlLangAttribute = (locale?: string) =>
  routingLocaleToLanguageTag[(locale as Locales) || Locales.UK];
